

export const isEmptyValue = (value) => {

    return value.trim().length === 0;
}


export const isEmail = (email) => {

    return isValidEmail(email) 
        ? undefined
        : 'El correo no parece ser válido';
}
  

export const isValidEmail = (email) => {
  
    const match = String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    return !!match;
};
  


export const logObject = (item) => {
    
    Object.keys(item).forEach( k => console.log(`${ k }:`, item[k]) );
}